import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Title } from './textBlock.styles';
import { Button } from '../button/button.component';
import { Text } from '../text';
import { getField } from '../../utils/cmsData';

export class TextBlock extends PureComponent {
  static propTypes = {
    buttonType: PropTypes.string,
    className: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string,
    link: PropTypes.object,
    linkLabel: PropTypes.string,
  };

  get url() {
    return getField('url', this.props.link);
  }

  get label() {
    return this.props.linkLabel;
  }

  render() {
    const {
      buttonType,
      className,
      title,
      content,
    } = this.props;

    return (
      <div className={className}>
        { title && <Title>{title}</Title> }
        { content && <Text text={content} /> }
        {
          this.url &&
            <Button
              url={this.url}
              label={this.label}
              buttonType={buttonType}
            />
        }
      </div>
    );
  }
}
